import { EmptyState, Button } from '@kollektive/design-system';
import { HelpCircle } from 'lucide-react';
import styles from './TenantNotFound.module.css';

interface TenantNotFoundProps {
  slug?: string;
}

export function TenantNotFound({ slug }: TenantNotFoundProps) {
  const description = slug
    ? `The workspace "${slug}" doesn't exist or you don't have access.`
    : 'Please access this portal through your workspace subdomain.';

  return (
    <div className={styles.container}>
      <EmptyState
        icon={<HelpCircle size={48} />}
        title="Workspace Not Found"
        description={description}
        action={
          <Button
            variant="secondary"
            onClick={() => window.location.href = 'https://kollektive.ai'}
          >
            Go to Kollektive home
          </Button>
        }
      />
      <div className={styles.footer}>
        <p className={styles.footerText}>
          If you believe this is an error, please contact your administrator or{' '}
          <a href="mailto:support@kollektive.ai" className={styles.link}>
            Kollektive support
          </a>
          .
        </p>
      </div>
    </div>
  );
}
